<script setup lang="ts">
/** Aventross AGM (Audited) — 원본 합본 문서 10부(Company Full Name: [[company_name]]). gen_vue 로 템플릿 글자 그대로 생성. */
import CddVarField from '../../../aura/agm/cdd/CddVarField.vue';
import DocScope from '../../../aura/agm/cdd/DocScope.vue';
import AgmSigners from '../../../aura/agm/cdd/AgmSigners.vue';
import { useRepeat } from '../useRepeat';
import '../../../aura/agm/docs/agmDoc.css';
import '../avDoc.css';

const R = useRepeat();
void CddVarField; void DocScope; void AgmSigners;
</script>

<template>
  <div class="agm-doc av-doc">
    <template v-for="id_ctrl in R.ids('ctrl')" :key="'ctrl' + id_ctrl">
      <DocScope :scope="'ctrl_' + id_ctrl + '/'">
        <div class="rep-item"><div class="rep-bar"><span>Controller #{{ id_ctrl }}</span><button type="button" class="rep-rm" title="Remove" @click="R.remove('ctrl', id_ctrl)">×</button></div>
          <p class="doc-p center bold">ANNEX A - REGISTER OF REGISTRABLE CONTROLLERS</p>
          <div class="gap" />
          <p class="doc-p">Company Full Name: <DocScope scope=""><CddVarField field-key="company_name" label="Company Name" /></DocScope></p>
          <p class="doc-p">Registration Number: <DocScope scope=""><CddVarField field-key="company_registration_no" label="Company Registration No." /></DocScope></p>
          <div class="gap" />
          <table class="cdd-tbl av-tbl">
            <tbody>
              <tr><th>Date of Entry</th><th>Name of Registrable Controller</th><th colspan="2">Particulars</th><th>Remarks</th></tr>
              <tr><td rowspan="10"><CddVarField field-key="controller_entry_date" label="Entry date" /></td><td rowspan="10">As of <DocScope scope=""><CddVarField field-key="controllers_as_of_date" label="As of date" /></DocScope>, the the Company has not received any notice from any registrable controller of the Company.<br /><br />Or <br /><br /><CddVarField field-key="controller_name" label="Name" /></td><td>Full Name:</td><td><CddVarField field-key="controller_name" label="Name" /></td><td rowspan="10">Sent Confirmation on <CddVarField field-key="controller_confirmation_sent_date" label="Confirmation sent date" /><br /><br />Received Confirmation on <CddVarField field-key="controller_confirmation_received_date" label="Confirmation received date" /></td></tr>
              <tr><td>Alias:</td><td><CddVarField field-key="controller_alias" label="Alias" /></td></tr>
              <tr><td>Residential address:</td><td><CddVarField field-key="controller_residential_address" label="Residential address" /></td></tr>
              <tr><td>Email address:</td><td><CddVarField field-key="controller_email" label="Email" /></td></tr>
              <tr><td>Contact number:</td><td><CddVarField field-key="controller_contact_no" label="Contact no" /></td></tr>
              <tr><td>Nationality:</td><td><CddVarField field-key="controller_nationality" label="Nationality" /></td></tr>
              <tr><td>Identity card number:</td><td><CddVarField field-key="controller_id_no" label="Id no" /></td></tr>
              <tr><td>Date of birth:</td><td><CddVarField field-key="controller_date_of_birth" label="Date of birth" /></td></tr>
              <tr><td></td><td></td></tr>
              <tr><td>Date on which the individual became a registrable controller of the Company.</td><td><CddVarField field-key="controller_start_date" label="Start date" /></td></tr>
              <tr><td></td><td></td><td>Date on which the individual ceased to be a registrable controller of the Company..</td><td><CddVarField field-key="controller_cessation_date" label="Cessation date" /></td><td></td></tr>
            </tbody>
          </table>
          <div class="gap" />
        </div>
      </DocScope>
    </template>
    <button type="button" class="rep-add" @click="R.add('ctrl')">+ Add controller</button>
    <div class="gap" />
  </div>
</template>
